import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  showLinks: boolean;
}

const Header: React.FC<HeaderProps> = ({ showLinks }) => {
  const { t } = useTranslation();

  return (
    <>
      <header>
        <nav className='container'>
          <div className='logo'>Sports Deals</div>
          <ul className='nav-links'>
            {showLinks && (
              <>
                <li>
                  <a href='/#features'>Features</a>
                </li>
                <li>
                  <a href='/#newsletter'>Newsletter</a>
                </li>
                <li>
                  <a href='/#coming-soon'>Coming Next</a>
                </li>
              </>
            )}
            <li>
              <Link to='/user/signin'>
                <div className='outer-space-20px'>{t('MENU.SIGN_IN')}</div>
              </Link>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
